import { render } from "./GoalSocial.vue?vue&type=template&id=36eaa0f6"
import script from "./GoalSocial.vue?vue&type=script&lang=js"
export * from "./GoalSocial.vue?vue&type=script&lang=js"
script.render = render

export default script